import React, { Component, Fragment } from 'react';
import Panel from '@/components/Panel';
import { createPortal } from 'react-dom';
import { PlusCircleOutlined, CloseOutlined } from '@ant-design/icons';
import EditableTable from '@/components/EditableTable';
import { splitNumUnit } from '../../../../services/helper/numberHelper';
import { numberCheck } from '../../../../services/helper/dataProcess';
import './index.css'

const unitList = ['Hz', 'KHz', 'MHz', 'GHz', 'YHz']

const columns = [{
  title: 'Freqeuncy Value',
  dataIndex: 'marker',
  width: '100%'
}];

class MarkerSettingPanel extends Component {

  constructor(props) {
    super(props);
    this.dialogRoot = document.getElementById('root');
    this.state = {
      markerList: [],
      error: null
    }
  }

  componentDidMount = () => {
    this.initData()
    this.initColums()
  }

  initData = () => {
    const { markerList } = this.props
    this.setState({
      markerList
    })
  }

  initColums = () => {
    columns[0].render = (text, record) => {
      const { marker } = record
      const { num, unit } = splitNumUnit(marker);
      const value = num ? num : ''
      return <div className='pdn-result-component-part'>
        {value ? marker : ''}
        <CloseOutlined
          className="cascade-marker-delete-icon"
          onClick={(e) => this.deleteRow(e, record)} />
      </div>
    };

    columns[0].onCell = (record) => {
      const { marker } = record;
      const { num, unit } = splitNumUnit(marker);
      const value = num ? num : ''
      return {
        record: { ...record, marker: value, unit: unit && unitList.includes(unit) ? unit : 'MHz' },
        edit: 'input-with-select',
        unitList,
        dataIndex: 'marker',
        allowEmpty: true,
        decimals: 3,
        handleSave: (row) => this.saveMarker(row)
      }
    }
  }

  saveMarker = (row) => {
    const { index, unit, value } = row;
    const { markerList } = this.state;
    let newMarker = `${value}${unit}`
    if (index > -1) {
      markerList[index].marker = newMarker;
      this.setState({
        markerList
      })
    }
  }

  addTableRow = (e) => {
    const { markerList } = this.state;
    let newIndex = markerList.length ? markerList[markerList.length - 1].index + 1 : 0;
    const newMarkerList = [...markerList, { marker: '', index: newIndex }]
    this.setState({
      markerList: newMarkerList
    })
  }

  deleteRow = (e, record) => {
    e.stopPropagation();
    const { index } = record;
    const { markerList } = this.state;
    let newMarkerList = markerList.filter(item => item.index !== index).map((item, index) => { return { ...item, index } });
    this.setState({
      markerList: newMarkerList,
    })
  }

  closeModal = () => {
    const { markerList } = this.state;
    for (const item of markerList) {
      const marker = item.marker || '';
      const { num } = splitNumUnit(marker);
      const error = numberCheck(num);
      if (error) {
        this.setState({ error });
        return;
      }
    }
    this.setState({ error: '' });
    this.props.closeModal(markerList);
  };

  render() {
    const { error, markerList } = this.state
    const content = (
      <Panel
        className='cascade-marker-setting-panel'
        id='cascade-marker-setting-panel'
        zIndex={2000}
        onCancel={this.closeModal}
        width={300}
        maxHeight={1000}
        draggable
        minWidth={200}
        minHeight={200}
        position={'panel-center-left'}
        title='Marker Setting'
        overflow={"auto"}
      >
        <div className='cascade-marker-setting-content'>
          <div className='cascade-marker-setting-body cascade-setup-border'>
            <Fragment>
              <span className='font-bold cascade-marker-value-span' >
                <span>Marker</span>
              </span>
              <PlusCircleOutlined
                title="Add table row"
                className='cascade-imp-icon'
                onClick={(e) => this.addTableRow(e)} />
            </Fragment>
            <div className="cascade-marker-table-content">
              <EditableTable
                rowKey={(record, index) => index}
                columns={columns}
                size="small"
                dataSource={markerList}
                className='cascade-marker-table'
                tableLayout="fixed"
              />
            </div>
          </div>
          {error && <span className='imp-current-name-error-msg'>{error}</span>}
        </div>
      </Panel>
    )
    return createPortal(content, this.dialogRoot)
  }
}

export default MarkerSettingPanel;